import { WorkoutMovementWithScoring } from 'components/Workout/logging';
import { MovementTypeEnum } from 'types/enums';

export type MovementWithSection = WorkoutMovementWithScoring & {
  sectionName: string;
  workoutSectionId: string;
  levelScaled: boolean;
  levelRx: boolean;
  levelRxPlus: boolean;
};

export interface MovementLabel {
  title: string;
  meta: string;
  isActiveBenchmark: boolean;
}

// A section-level movement is backed by either a reusable library benchmark or a one-off
// created just for this section. Only the one-off has no name worth showing as the title.
// Shared by the staff Whiteboard and the athlete leaderboard screen — each surface joins
// title/meta into its own display string, since the two conventions differ.
export const getMovementLabel = (movement: MovementWithSection): MovementLabel => {
  const kind = movement.workoutMovement?.movementType;
  const isSectionLevel = kind === MovementTypeEnum.BENCHMARK || kind === MovementTypeEnum.SCORED_SECTION;
  const isActiveBenchmark = isSectionLevel && movement.workoutMovement?.deletedAt == null;
  return {
    title: isSectionLevel && !isActiveBenchmark ? movement.sectionName : movement.workoutMovementName,
    meta: isSectionLevel && !isActiveBenchmark ? 'Scored Section' : movement.sectionName,
    isActiveBenchmark,
  };
};
